<template>
  <div style="display: flex;flex-wrap: wrap;">
    <div class="common-btn research-font-color" @click="$emit('goToProgress', orderDetail)" v-if="showProgressBtn">进展查询</div>
    <div class="common-btn research-font-color" @click="$emit('downloadOrderText', orderDetail)" v-if="showDownloadContractBtn">下载合同</div>
  </div>
</template>

<script>
// import EMKT from '../../constant'

import EMKT from '../../../constant'

export default {
  emits: ['goToProgress', 'downloadOrderText'],
  props: {
    orderDetail: {
      type: Object,
      required: true
    }
  },
  computed: {
    showProgressBtn () {
      return EMKT.showProgressBtn(this.orderDetail) && !EMKT.isGVAPContract(this.orderDetail)
    },
    showDownloadContractBtn () {
      // 线下订单不支持下载合同文本
      return EMKT.showDownloadOrderTextBtn(this.orderDetail)
    }
  },
  methods: {
    getOrderStatusText: EMKT.getOrderStatusText
  }
}
</script>

<style scoped>
.common-btn {
  width: 73px;
  height: 23px;
  border-radius: 44px;
  line-height: 23px;
  text-align: center;
  font-size: 12px;
  background-color: #fff;
  border: 1px solid #5878fa;
  margin-left: 10px;
}

</style>



// WEBPACK FOOTER //
// GcOrderListButtonsBase.vue?365b9a1c